import StocktakeSelectAllButton from './StocktakeSelectAllButton.js'
import {referenceIDListSelector} from './stocktakeListFunctions.js'
import Row from './Row.js'
import EmptyList from './EmptyList.js'
import {useSelector} from '../../store.js'

export default function Table() {
  const referenceIDList = useSelector(referenceIDListSelector)

  return (
    <table className="table table--zebra-list table--product-list">
      <thead>
        <tr className="table__tr">
          <th className="table__th table__th--sm v-align-middle no-border table__th--order-checkbox">
            <StocktakeSelectAllButton />
          </th>
          <th className="table__th table__th--sm th-width-25 v-align-middle no-border">
            <span className="fs-00 lh-md">Stocktake ID</span>
          </th>
          <th className="table__th table__th--sm th-width-35 v-align-middle no-border">
            <span className="fs-00 lh-md">Contents</span>
          </th>
          <th className="table__th table__th--sm th-width-20 v-align-middle no-border">
            <span className="fs-00 lh-md">Warehouse</span>
          </th>
          <th className="table__th table__th--sm th-width-15 v-align-middle no-border">
            <span className="fs-00 lh-md">Date Created</span>
          </th>
          <th className="table__th table__th--sm v-align-middle no-border" />
        </tr>
      </thead>
      <tbody className="table__tbody--full-border">
        {referenceIDList.map((referenceID) => (
          <Row key={referenceID} referenceID={referenceID} />
        ))}
        {referenceIDList.length === 0 && <EmptyList colSpan="6" />}
      </tbody>
    </table>
  )
}
